import { InjectionToken } from '@angular/core';

/**
 * The keys of the documents a node outlet's subtree was resolved from, the nearest last. Each outlet that resolves a
 * reference adds its key for the outlets below it, so a reference back to one of those documents fails as a cycle
 * (670359). Internal to this library: only the node outlet provides it and reads its parent's.
 */
export const SCHEMA_REFERENCE_CHAIN = new InjectionToken<() => readonly string[]>('SCHEMA_REFERENCE_CHAIN');
